'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var $ = jQuery;

/**
 * SearchTemperatureMarker - Displays temperature at searched location
 * Works with both Leaflet and Mapbox GL map services
 */

var SearchTemperatureMarker = function () {
    function SearchTemperatureMarker(mapService, coordinates) {
        var temperatureData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        _classCallCheck(this, SearchTemperatureMarker);

        this.mapService = mapService;
        this.coordinates = coordinates; // {lat, lng}
        this.temperatureData = temperatureData; // {current, high, low}
        this.marker = null;
        this.markerElement = null;

        // Always create the marker visually, even if we don't have temperature yet
        this.create();
    }

    _createClass(SearchTemperatureMarker, [{
        key: 'create',
        value: function create() {
            var mapType = this.mapService.constructor.name;

            if (mapType === 'LeafletOSMMapService') {
                this.createLeafletMarker();
            } else if (mapType === 'MapboxGLMapService') {
                this.createMapboxMarker();
            }
        }
    }, {
        key: 'createLeafletMarker',
        value: function createLeafletMarker() {
            // Create custom HTML for the marker
            var html = this.generateMarkerHTML();

            // Create Leaflet div icon
            var icon = window.L.divIcon({
                className: 'mpfy-search-temp-marker',
                html: html,
                iconSize: [60, 60],
                iconAnchor: [30, 60]
            });

            // Create marker at coordinates
            this.marker = window.L.marker([this.coordinates.lat, this.coordinates.lng], { icon: icon });

            // Add to map
            this.marker.addTo(this.mapService.map);

            // Store reference to DOM element
            this.markerElement = this.marker.getElement();
        }
    }, {
        key: 'createMapboxMarker',
        value: function createMapboxMarker() {
            // Create custom HTML element for the marker
            var el = document.createElement('div');
            el.className = 'mpfy-search-temp-marker';
            el.innerHTML = this.generateMarkerHTML();

            // Create Mapbox GL marker
            this.marker = new mapboxgl.Marker({
                element: el,
                anchor: 'bottom'
            }).setLngLat([this.coordinates.lng, this.coordinates.lat]).addTo(this.mapService.map);

            // Store reference to DOM element
            this.markerElement = el;
        }
    }, {
        key: 'generateMarkerHTML',
        value: function generateMarkerHTML() {
            var tempDisplay = void 0;
            if (this.temperatureData !== null) {
                var unit = this.temperatureData.format === 'celsius' ? '°C' : '°F';
                tempDisplay = '\n                <div class="mpfy-temp-current">Current: ' + Math.round(this.temperatureData.current) + unit + '</div>\n                <div class="mpfy-temp-high-low">\n                    <span class="mpfy-temp-high">High: ' + Math.round(this.temperatureData.high) + unit + '</span>\n                    <span class="mpfy-temp-low">Low: ' + Math.round(this.temperatureData.low) + unit + '</span>\n                </div>\n            ';
            } else {
                tempDisplay = '<div class="mpfy-temp-loading">...</div>';
            }

            return '\n            <div class="mpfy-temp-marker-container">\n                <div class="mpfy-temp-marker-pin"></div>\n                <div class="mpfy-temp-marker-badge">' + tempDisplay + '</div>\n            </div>\n        ';
        }
    }, {
        key: 'update',
        value: function update(temperatureData) {
            this.temperatureData = temperatureData;

            if (this.markerElement) {
                var badge = this.markerElement.querySelector('.mpfy-temp-marker-badge');
                if (badge) {
                    var unit = temperatureData.format === 'celsius' ? '°C' : '°F';
                    badge.innerHTML = '\n                    <div class="mpfy-temp-current">Current: ' + Math.round(temperatureData.current) + unit + '</div>\n                    <div class="mpfy-temp-high-low">\n                        <span class="mpfy-temp-high">High: ' + Math.round(temperatureData.high) + unit + '</span>\n                        <span class="mpfy-temp-low">Low: ' + Math.round(temperatureData.low) + unit + '</span>\n                    </div>\n                ';
                }
            }
        }
    }, {
        key: 'remove',
        value: function remove() {
            var _this = this;

            if (this.marker && this.markerElement) {
                var mapType = this.mapService.constructor.name;

                // Add fade-out class to trigger animation
                this.markerElement.classList.add('mpfy-search-temp-marker-removing');

                // Wait for animation to complete before removing
                setTimeout(function () {
                    if (_this.marker) {
                        if (mapType === 'LeafletOSMMapService') {
                            _this.mapService.map.removeLayer(_this.marker);
                        } else if (mapType === 'MapboxGLMapService') {
                            _this.marker.remove();
                        }

                        _this.marker = null;
                        _this.markerElement = null;
                    }
                }, 300); // Match animation duration in CSS
            }
        }
    }, {
        key: 'setCoordinates',
        value: function setCoordinates(lat, lng) {
            this.coordinates = { lat: lat, lng: lng };

            if (this.marker) {
                var mapType = this.mapService.constructor.name;

                if (mapType === 'LeafletOSMMapService') {
                    this.marker.setLatLng([lat, lng]);
                } else if (mapType === 'MapboxGLMapService') {
                    this.marker.setLngLat([lng, lat]);
                }
            }
        }
    }, {
        key: 'show',
        value: function show() {
            if (this.markerElement) {
                this.markerElement.style.display = '';
            }
        }
    }, {
        key: 'hide',
        value: function hide() {
            if (this.markerElement) {
                this.markerElement.style.display = 'none';
            }
        }
    }, {
        key: 'isVisible',
        value: function isVisible() {
            return this.marker !== null && this.markerElement && this.markerElement.style.display !== 'none';
        }
    }]);

    return SearchTemperatureMarker;
}();

module.exports = SearchTemperatureMarker;


//////////////////
// WEBPACK FOOTER
// ./assets/js/src/public/search-temperature-marker.js
// module id = 21
// module chunks = 0